module.exports = __webpack_public_path__ + "static/media/check.1613cf40.svg";